export interface SortFilterOption {
  value: server.dto.ContactSort
  label: string
  enabled: boolean
}

export interface ContactSortFilterType {
  sortOption: SortFilterOption
}

export const ContactSortOptions: SortFilterOption[] = [
  {
    value: "name_asc",
    label: RESX.GeneralLabels.Name,
    enabled: true
  },
  {
    value: "lastmodified_desc",
    label: RESX.GeneralLabels.LastModified,
    enabled: true
  },
  {
    value: "isvalidated_asc",
    label: RESX.Planning.NotYetChecked,
    enabled: true
  }
];

export const DefaultContactSortFilter: server.dto.ContactSort = "name_asc";

export const getSortOption = (value: server.dto.ContactSort) => {
  if (value === "unknown") return ContactSortOptions[0];
  return ContactSortOptions.find((s) => s.value === value);
};

export const initialContactSortFilter: ContactSortFilterType = {
  sortOption: getSortOption(DefaultContactSortFilter)
};
